import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';

import { ITINERARY_FOOD_INVOICE_PATH } from '../../../../config/paths';

import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';

import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';

import ItineraryFoodInvoiceBasicInformationResource from './resource/ItineraryFoodInvoiceBasicInformationResource';

import {
  clearItineraryFoodInvoice,
  getItineraryFoodInvoice,
} from '../../../../actions/food/ItineraryFoodInvoice';
import ItineraryFoodInvoiceToolbar from './ItineraryFoodInvoiceToolbar';

export const ItineraryFoodInvoice = ({
  breadcrumbs,
  dispatchGetItineraryFoodInvoice,
  dispatchClearItineraryFoodInvoice,
  match: {
    params: { id: itineraryFoodInvoiceId },
  },
  loading,
  itineraryFoodInvoice,
}) => {
  useLayoutEffect(() => {
    dispatchGetItineraryFoodInvoice({ itineraryFoodInvoiceId });

    return () => dispatchClearItineraryFoodInvoice();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (itineraryFoodInvoice.isEmpty()) {
    content = <NoDataResource returnPage={ITINERARY_FOOD_INVOICE_PATH} />;
  } else {
    const itineraryFoodInvoiceJson = itineraryFoodInvoice.toJS();

    content = (
      <>
        <h3>Información Básica</h3>
        <ItineraryFoodInvoiceBasicInformationResource
          {...itineraryFoodInvoiceJson}
        />
      </>
    );

    toolbar = (
      <ItineraryFoodInvoiceToolbar
        itineraryFoodInvoiceId={itineraryFoodInvoiceJson.id}
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Factura de Alimentación"
      content={content}
      toolbar={toolbar}
    />
  );
};

ItineraryFoodInvoice.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearItineraryFoodInvoice: PropTypes.func.isRequired,
  dispatchGetItineraryFoodInvoice: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  itineraryFoodInvoice: PropTypes.instanceOf(Immutable.Map).isRequired,
};

ItineraryFoodInvoice.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearItineraryFoodInvoice: clearItineraryFoodInvoice,
  dispatchGetItineraryFoodInvoice: getItineraryFoodInvoice,
};

const mapStateToProps = ({ FoodUnit }) => ({
  breadcrumbs: [
    ...FoodUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Facturas de Alimentación',
      href: ITINERARY_FOOD_INVOICE_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  itineraryFoodInvoice: FoodUnit.ItineraryFoodInvoice.getIn([
    'current',
    'content',
  ]),
  loading: !FoodUnit.ItineraryFoodInvoice.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ItineraryFoodInvoice);
